<div class="admin-reports" style="margin-top: 1px; display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: flex-start; align-items: stretch;">

  <div style="order: 1; flex-shrink: 0;">
    <p-accordion multiple="true" class="reports-sidebar">
      <p-accordionTab [disabled]="true" [selected]="true">
        <p-header><span style="text-decoration: underline;">Reports</span></p-header>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == AssetInventoryReport" (click)="selectReport(AssetInventoryReport)">Asset/Inventory</span>
        </div>
        <div style="margin-bottom: 5px;">
          <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
          <span class="clickable-reports-item" [class.active]="selectedReport == DiscoveryAuditReport" (click)="selectReport(DiscoveryAuditReport)">Discovery Audit</span>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

  @if (!!selectedReport) {
    <div style="order: 2; flex-grow: 1; border-style: solid; border-color: rgb(235,235,235); overflow-x:hidden;">
      <report-viewer style="width: 100%;" [infoSetView]="selectedReportInfo"></report-viewer>
    </div>
  }

  @if (!selectedReport) {
    <div
      style="order: 2; flex-grow: 1; text-align: center; padding-top: 50px; font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: x-large; overflow-x:hidden">
      Select a report to view its details
    </div>
  }

</div>
